import React from "react";
import { Check } from "lucide-react";

const STEPS = [
  { id: 1, label: "Business Details" },
  { id: 2, label: "Terms" },
  { id: 3, label: "Onboarding" },
];

export const Stepper = ({ currentStep = 1 }) => {
  return (
    <div data-testid="stepper" className="flex items-center w-full max-w-2xl">
      {STEPS.map((step, index) => {
        const isCompleted = currentStep > step.id;
        const isCurrent = currentStep === step.id;
        const state = isCompleted ? "completed" : isCurrent ? "current" : "upcoming";

        return (
          <React.Fragment key={step.id}>
            <div
              data-testid={`step-${step.id}`}
              data-state={state}
              className="flex items-center gap-2.5 shrink-0"
            >
              <div
                className={[
                  "flex items-center justify-center h-8 w-8 rounded-full border transition-colors duration-300 text-sm font-semibold",
                  isCompleted && "border-[#F5C518] text-[#F5C518] bg-transparent",
                  isCurrent && "border-[#F5C518] bg-[#F5C518] text-black font-bold",
                  !isCompleted && !isCurrent && "border-white/20 text-white/40 bg-transparent",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                {isCompleted ? <Check className="h-4 w-4" strokeWidth={3} /> : step.id}
              </div>
              <span
                className={[
                  "font-body text-sm hidden md:inline transition-colors duration-300",
                  isCurrent ? "text-white font-semibold" : "text-white/50",
                ].join(" ")}
              >
                {step.label}
              </span>
            </div>

            {index < STEPS.length - 1 && (
              <div className="flex-1 h-px mx-3 bg-white/10 relative overflow-hidden">
                <div
                  className="absolute inset-y-0 left-0 bg-[#F5C518] transition-all duration-500"
                  style={{ width: currentStep > step.id ? "100%" : "0%" }}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
